"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expandText = exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _localization = require("@lt/localization");

var _Bubble = _interopRequireDefault(require("../../Bubble"));

var _QuestionCircle = _interopRequireDefault(require("../../../icons-react/QuestionCircle"));

var _CheckoutExtraOption = _interopRequireDefault(require("./CheckoutExtraOption"));

var _pluralizeUtils = require("../../../utils/pluralizeUtils");

var _constants = require("./constants.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var expandText = function expandText(count) {
  return "".concat(_localization.i18n.t('checkout.services.showMore'), " ").concat(count, " ").concat((0, _pluralizeUtils.pluralizeOptions)(count));
};

exports.expandText = expandText;

var CheckoutExtra = function CheckoutExtra(props) {
  var title = props.title,
      tooltip = props.tooltip,
      prependText = props.prependText,
      _props$hierarchy = props.hierarchy,
      hierarchy = _props$hierarchy === void 0 ? false : _props$hierarchy,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      onChange = props.onChange,
      chosenOptions = props.chosenOptions,
      uncheckOption = props.uncheckOption;
  var hasExpandText = Boolean((options === null || options === void 0 ? void 0 : options.length) > _constants.OPTIONS_COLLAPSED_LENGTH);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      touched = _useState4[0],
      setTouched = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      chosenOption = _useState6[0],
      setChosenOption = _useState6[1];

  var renderOptions = expanded ? options : options.slice(0, _constants.OPTIONS_COLLAPSED_LENGTH);
  var showExpandText = hasExpandText && !expanded;
  var hiddenOptionsCount = options.length - _constants.OPTIONS_COLLAPSED_LENGTH;

  var optionChangeHandler = function optionChangeHandler(option, checked) {
    /**
     * Было добавлено локальное состояние useState для того, чтобы при нажатии чекбокса
     * в стор добавлялась услуга, но при этом затиралась другая из этого же списка
     */
    if (checked) {
      onChange(option.hashsum);
      uncheckOption(chosenOption);
      setChosenOption(option.hashsum);
      setTouched(true);
    } else {
      uncheckOption(option.hashsum);
      setChosenOption('');
      setTouched(false);
    }
  };

  var hasPrepenText = Boolean(prependText);
  var hasTitle = hierarchy;

  var isOptionChecked = function isOptionChecked(option) {
    return chosenOptions.includes(option.hashsum);
  };

  var showTooltipInOption = tooltip && !hierarchy;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hasTitle ? /*#__PURE__*/_react["default"].createElement(StyledTitleContainer, null, /*#__PURE__*/_react["default"].createElement(StyledTitle, null, hasPrepenText ? "".concat(prependText, " ").concat(title) : title), tooltip ? /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
    text: tooltip
  }, /*#__PURE__*/_react["default"].createElement(StyledQuestionIcon, null)) : null) : null, /*#__PURE__*/_react["default"].createElement(StyledOptoinsContainer, null, renderOptions.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_CheckoutExtraOption["default"], {
      key: option.hashsum,
      touched: touched,
      checked: isOptionChecked(option),
      onChange: optionChangeHandler,
      option: option,
      tooltip: showTooltipInOption ? tooltip : undefined
    });
  })), showExpandText ? /*#__PURE__*/_react["default"].createElement(StyledExpandText, {
    onClick: function onClick() {
      return setExpanded(!expanded);
    }
  }, expandText(hiddenOptionsCount)) : null);
};

var StyledQuestionIcon = (0, _styledComponents["default"])(_QuestionCircle["default"]).withConfig({
  displayName: "CheckoutExtra__StyledQuestionIcon",
  componentId: "sc-16b140o-0"
})(["cursor:pointer;width:14px;height:14px;margin-left:4px;vertical-align:bottom;margin-bottom:1px;circle{stroke:#919499;}path{stroke:#919499;}"]);

var StyledOptoinsContainer = _styledComponents["default"].div.withConfig({
  displayName: "CheckoutExtra__StyledOptoinsContainer",
  componentId: "sc-16b140o-1"
})([""]);

var StyledTitleContainer = _styledComponents["default"].div.withConfig({
  displayName: "CheckoutExtra__StyledTitleContainer",
  componentId: "sc-16b140o-2"
})(["display:flex;flex-direction:row;align-items:center;margin-top:16px;div + div{margin-left:4px;}"]);

var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "CheckoutExtra__StyledTitle",
  componentId: "sc-16b140o-3"
})(["font-family:Backpack;font-style:normal;font-weight:bold;font-size:14px;line-height:16px;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blackLight;
});

var StyledExpandText = _styledComponents["default"].div.withConfig({
  displayName: "CheckoutExtra__StyledExpandText",
  componentId: "sc-16b140o-4"
})(["font-family:Backpack;font-style:normal;font-weight:normal;font-size:14px;line-height:16px;margin-top:8px;cursor:pointer;color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.blue;
});

var _default = CheckoutExtra;
exports["default"] = _default;